const mainHeaderRootElements = document.querySelectorAll('.main-header__nav .nav.nav--primary > li');

// Vertraging voor het openen, zodat het menu niet flikkert bij snel er langs bewegen.
const OPEN_DELAY = 175;
// Grace-periode voor het sluiten: houdt het submenu open terwijl de cursor
// diagonaal onderweg is naar een submenu-item (voorkomt vroegtijdig sluiten).
const CLOSE_DELAY = 250;

function openDropdown(element) {
    element.classList.add('active');

    const navAnchorWithChildren = element.querySelector('.nav-link--has-children');

    if (navAnchorWithChildren) {
        navAnchorWithChildren.setAttribute('aria-expanded', 'true');
    }
}

function closeDropdown(element) {
    element.classList.remove('active');

    const navAnchorWithChildren = element.querySelector('.nav-link--has-children');

    if (navAnchorWithChildren) {
        navAnchorWithChildren.setAttribute('aria-expanded', 'false');
    }
}

if (mainHeaderRootElements) {
    mainHeaderRootElements.forEach((element) => {
        let openTimeout;
        let closeTimeout;
        const navAnchorWithChildren = element.querySelector('.nav-link--has-children');
        const navDropdown = element.querySelector('.nav__dropdown');

        element.addEventListener('mouseenter', () => {
            // Annuleer een eventueel geplande sluiting: de cursor is (terug)
            // binnen het menu, bijvoorbeeld doordat hij de dropdown heeft bereikt.
            clearTimeout(closeTimeout);

            openTimeout = setTimeout(() => {
                openDropdown(element);
            }, OPEN_DELAY);
        });

        element.addEventListener('mouseleave', () => {
            // Annuleer een nog niet uitgevoerde opening.
            clearTimeout(openTimeout);

            // Sluit niet direct: geef de cursor de tijd om diagonaal naar de
            // dropdown te bewegen. Komt hij binnen de grace-periode terug in het
            // menu, dan wordt closeTimeout via mouseenter geannuleerd.
            closeTimeout = setTimeout(() => {
                closeDropdown(element);
            }, CLOSE_DELAY);
        });

        if (navAnchorWithChildren) {
            navAnchorWithChildren.addEventListener('keydown', (e) => {
                if (e.code === 'Space' || e.code === 'Enter') {
                    element.classList.toggle('active');
                    navAnchorWithChildren.setAttribute('aria-expanded', 'true');
                    navDropdown.querySelector('a').focus();
                }
            });
        }

        if (navDropdown) {
            setupDropdownTabNavigation(element, navDropdown);
        }
    });

    document.addEventListener('keydown', function(event) {
        if (event.key === 'Escape') {
            closeAllDropdowns(mainHeaderRootElements);
        }
    });
}

/**
 * Sets up Tab navigation for dropdown items to comply with EAA accessibility rules
 * When tabbing from the last item in a submenu, closes the dropdown and lets
 * the browser's natural tab behavior handle moving to the next element
 */
function setupDropdownTabNavigation(element, navDropdown) {
    const dropdownLinks = navDropdown.querySelectorAll('a');

    if (dropdownLinks.length === 0) return;

    const lastDropdownLink = dropdownLinks[dropdownLinks.length - 1];

    lastDropdownLink.addEventListener('keydown', (e) => {
        if (e.key === 'Tab' && !e.shiftKey) {
            closeDropdown(element);
        }
    });
}

function closeAllDropdowns(mainHeaderRootElements) {
    mainHeaderRootElements.forEach((element) => {
        closeDropdown(element);
    });

    // Optioneel: focus terugzetten op het hoofdmenu of trigger-knop
    const activeTrigger = document.querySelector('.nav-link[aria-expanded="true"]');
    if (activeTrigger) {
        activeTrigger.setAttribute('aria-expanded', 'false');
        activeTrigger.focus();
    }
}
